import { useEffect, useState } from "react";
import { Users, Calendar, MessageSquare, Instagram } from "lucide-react";

interface StatCounter {
  current: number;
  target: number;
  increment: number;
}

export const StatisticsSection = () => {
  const [counters, setCounters] = useState<StatCounter[]>([
    { current: 0, target: 60, increment: 1 },      // Koç sayısı
    { current: 0, target: 500, increment: 25 },   // Öğrenci sayısı
    { current: 0, target: 40000, increment: 200 }, // Görüşme sayısı
  ]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCounters(prevCounters =>
        prevCounters.map(counter => ({
          ...counter,
          current: Math.min(counter.current + counter.increment, counter.target)
        }))
      );
    }, 50);

    const allCompleted = counters.every(counter => counter.current >= counter.target);
    if (allCompleted) {
      clearInterval(interval);
    }

    return () => clearInterval(interval);
  }, [counters]);

  const stats = [
    {
      icon: <Users className="w-8 h-8" />,
      label: "Aktif Koç",
      value: counters[0].current,
      suffix: "+"
    },
    {
      icon: <Calendar className="w-8 h-8" />,
      label: "Öğrenci",
      value: counters[1].current,
      suffix: "+"
    },
    {
      icon: <MessageSquare className="w-8 h-8" />,
      label: "Görüşme",
      value: counters[2].current,
      suffix: "+"
    },
  ];

  return (
    <section className="py-20 bg-[#0A0B1A]">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-8">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="text-center space-y-4"
            >
              <div className="mx-auto w-16 h-16 rounded-full bg-brand-primary/10 flex items-center justify-center text-brand-primary">
                {stat.icon}
              </div>
              <div>
                <div className="text-3xl md:text-4xl font-bold text-white mb-2">
                  {stat.value.toLocaleString('tr-TR')}{stat.suffix}
                </div>
                <div className="text-brand-white font-medium">
                  {stat.label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}; 